import React, { Component } from 'react';
import Schedule from '~/modules/TeamSchedule/Schedule';
import { getGames, nextGame } from '~/tools/mll/helpers';
import './UpcomingGames.css';

class UpcomingGames extends Component {
  state = {
    games: []
  }

  componentDidMount = () => {
    getGames().then((res) => {
      const index = nextGame(res)
      const sliced = res.slice(index, index + 3)
      this.setState({
        games: sliced
      })
    }).catch((err) => {
      console.log(err);
    });
  }

  render() {
    return (
      <div className='upcoming-games'>
        <h3 className='upcoming-games-title site-border-color'>{`${new Date().getFullYear()} Upcoming games`}</h3>
        {this.state.games.map((item, i) => (
          <Schedule
            key={i}
            homeTeam={item.homeTeam}
            awayTeam={item.awayTeam}
            schedule={item.schedule}
            ticket={item.ticket}
            stream={item.stream}
            link={item.link}
          />
        ))}
        <a className='schedule-link' href='/schedule-events'>Full schedule</a>
      </div>
    )
  }
}

export default UpcomingGames;